import React from 'react';
import { Input, Label } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import RoomDateInformation from '../RoomDateIformaton';
import { Controller, UseFormReturn } from 'react-hook-form';
import { RoomResource } from '../../../../store/RoomManagement/resourceManagementTypes';

type PropsTypes = {
  originalArray: number[];
  room: RoomResource;
  form: UseFormReturn<any, object>;
  onClickInvitedUsers: () => void;
  onDropdownChange?: () => void;
};

const BookRoomForm = (props: PropsTypes) => {
  const { control } = props.form;
  const { t } = useTranslation();

  return (
    <div className="book-room-form-content">
      <div className="book-room-form">
        <RoomDateInformation
          form={props.form}
          room={props.room}
          originalArray={props.originalArray}
        />
        <div
          className="book-room-invite-users-button"
          onClick={props.onClickInvitedUsers}
        >
          <span>
            {t('INVITED_USERS', {
              count: props.form.watch('invited_users')?.length || 0,
            })}
          </span>
        </div>
        <div className="message-form">
          <Label for="departmentName">{t('DEPARTMENT_NAME_LABEL')}</Label>
          <Controller
            name="departmentName"
            control={control}
            render={({ field }) => (
              <Input
                id="departmentName"
                type="text"
                className="text-input"
                placeholder={t('DEPARTMENT_NAME_LABEL')}
                {...field}
              />
            )}
          />
        </div>
        <div className="message-form">
          <Label for="meetingSubject">{t('MEETING_SUBJECT_LABEL')}</Label>
          <Controller
            name="meetingSubject"
            control={control}
            render={({ field }) => (
              <Input
                id="meetingSubject"
                type="text"
                className="text-input"
                placeholder={t('MEETING_SUBJECT_LABEL')}
                {...field}
              />
            )}
          />
        </div>
        <div className="message-form">
          <Label for="messageForAdmin">{t('MESSAGE_FOR_ADMIN_LABEL')}</Label>
          <Controller
            name="messageForAdmin"
            control={control}
            render={({ field }) => (
              <Input
                id="messageForAdmin"
                type="textarea"
                className="text-input"
                placeholder={t('MESSAGE_FOR_ADMIN_TEXT')}
                {...field}
              />
            )}
          />
        </div>
      </div>
    </div>
  );
};

export default BookRoomForm;
